// src/components/utils/Loader.jsx
import React from 'react';

const Loader = () => (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999] backdrop-blur-sm">
    <div className="relative">
      {/* Outer Ring */}
      <div className="w-20 h-20 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Inner Ring (reverse spin for cool effect) */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-14 h-14 border-4 border-blue-400 border-t-transparent rounded-full animate-spin animate-reverse"></div>
      </div>

      {/* Center Dot + Text */}
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="w-4 h-4 bg-blue-600 rounded-full animate-ping"></div>
        {/* <p className="mt-8 text-white font-medium text-sm tracking-wider">Loading...</p> */}
      </div>
    </div>
  </div>
);

export default Loader;